import { UserRole } from "../store/model-me";

const SAXECAP_DEV_ROUTES_PATT = RegExp("^/.*$");
const ADMIN_ROUTES_PATT = RegExp(
  "^/((signin)|(bookings)|(opportunities)|(skippings)|(suspends)|(planner_stats)|(platform_stats)|(dead_opps)).*$"
);
export const EMPLOYEE_ROUTES_PATT = RegExp(
  "^/((signin)|(bookings)|(opportunities)|(skippings)|(suspends)).*$"
);
export const ROLE_ALLOWED_ROUTES_PATTS = {
  [UserRole.SAXECAP_DEV]: SAXECAP_DEV_ROUTES_PATT,
  [UserRole.ADMIN_READ_WRITE]: ADMIN_ROUTES_PATT,
  [UserRole.ADMIN_READ_ONLY]: ADMIN_ROUTES_PATT,
  [UserRole.DEFAULT]: EMPLOYEE_ROUTES_PATT
};
export const USER_EXTRA_ALLOWED_ROUTES_PATTS = {
  "gregh@worldstrides.org": RegExp(
    "^/((planner_stats)|(platform_stats)|(dead_opps)).*$"
  ),
  "tims@worldstrides.org": RegExp("^/(platform_stats).*$")
};
